
import React, { Component, Fragment } from 'react';
import { setChannelCookie } from 'utils/utils'
import Header from 'components/Header';
import Footer from 'components/Footer';

import './Page.scss';
export default class Page extends Component {
	constructor(props) {
		super(props);
		this.state = {
			menuOpen: false,
			channel: setChannelCookie(this.props.url ? this.props.url : undefined)
		};
	}
	handleMenuClick() {
		this.setState({
			menuOpen: !this.state.menuOpen
		})
	}
	render() {
		return (
			<Fragment>
					<Header 
						fixedHeader={this.props.fixedHeader ? this.props.fixedHeader : false}
					/>
				{this.props.children}
				{
					!this.props.footerless
						? <Footer openFooter={this.props.openFooter} location={this.props.location} />
						: null
				}
			</Fragment>
		);
	}
}
